import type { IFAQQuestion } from '../../types';
import * as m from '@/paraglide/messages.js';
import { activeConfig } from '@/config';

export const getFAQQuestions = (): IFAQQuestion[] => [
  {
    question: m.faq_q1_question(),
    answer: m.faq_q1_answer({ companyName: activeConfig.branding.companyName }),
  },
  {
    question: m.faq_q2_question(),
    answer: m.faq_q2_answer({ companyName: activeConfig.branding.companyName }),
  },
  {
    question: m.faq_q3_question(),
    answer: m.faq_q3_answer({ companyName: activeConfig.branding.companyName }),
  },
  {
    question: m.faq_q4_question(),
    answer: m.faq_q4_answer({ email: activeConfig.contact.email }),
  },
  {
    question: m.faq_q5_question(),
    answer: m.faq_q5_answer(),
  },
  {
    question: m.faq_q6_question(),
    answer: m.faq_q6_answer(),
  },
];
